'use client';

import { c as _c } from "react/compiler-runtime";
import { Separator as SeparatorPrimitive } from 'radix-ui';
import { tv } from 'tailwind-variants';
import type { VariantProps } from 'tailwind-variants';
const separatorVariants = tv({
  base: `
    bg-border
    shrink-0
    data-[orientation=horizontal]:h-px
    data-[orientation=horizontal]:w-full
    data-[orientation=vertical]:h-full
    data-[orientation=vertical]:w-px
  `,
  variants: {
    variant: {
      default: 'bg-border-secondary',
      primary: 'bg-primary'
    }
  }
});
function Separator(t0) {
  const $ = _c(14);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      decorative: t2,
      variant: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  const decorative = t2 === undefined ? true : t2;
  const variant = t3 === undefined ? "default" : t3;
  let t4;
  if ($[6] !== className || $[7] !== variant) {
    t4 = separatorVariants({
      className,
      variant
    });
    $[6] = className;
    $[7] = variant;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== decorative || $[10] !== orientation || $[11] !== props || $[12] !== t4) {
    t5 = <SeparatorPrimitive.Root className={t4} data-slot="separator-root" decorative={decorative} orientation={orientation} {...props} />;
    $[9] = decorative;
    $[10] = orientation;
    $[11] = props;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
export { Separator };